import docCookies from '@/utils/cookie';

/**
 * **非生产环境** 添加 vconsole 控制
 * @description 可通过2种途径开启 vconsole
 * 1. 链接上增加一个 query : `isDebug=true`
 * 2. cookie 里设置 `vconsole_visible` 为 true
 */
function debugHook() {
  let isShowVConsole = false;
  const DEBUG_HOOK_VALUE = 'vconsole_visible';

  if (window.location.search.includes('isDebug=true')) {
    // 填到cookie里方便下次直接取值
    docCookies.setItem(
      DEBUG_HOOK_VALUE,
      'true',
      2 * 24 * 60 * 60,
      '/',
      window.location.host.split('.').slice(-2).join('.').replace(/:\d*$/g, ''),
    );
    localStorage.setItem(DEBUG_HOOK_VALUE, 'true');
    isShowVConsole = true;
  } else if (docCookies.getItem(DEBUG_HOOK_VALUE) === 'true') {
    isShowVConsole = true;
  } else if (localStorage.getItem(DEBUG_HOOK_VALUE) === 'true') {
    isShowVConsole = true;
  }

  if (process.env.NODE_ENV !== 'production' && isShowVConsole) {
    import('vconsole').then(module => {
      const { default: VConsole } = module;
      // eslint-disable-next-line no-new
      new VConsole();
    });
    (window as unknown as { __getFontSubsetLoad: () => void }).__getFontSubsetLoad = () => {
      const outputConfig = [
        {
          cls: 'font-ali',
          ruleName: 'fontSubsetAli',
          fontFilename: 'alimamafangyuanti',
        },
        {
          cls: 'font-noto',
          ruleName: 'fontSubsetNoto',
          fontFilename: 'NotoSansSC-Light',
        },
      ];
      const makeOutput = (content: string, ruleName: string, fontFilename: string) =>
        `  memo\n    .module\n    .rule('${ruleName}')\n    .test(/${fontFilename}.ttf$/)\n    .use('@qfe/font-subset-loader')\n    .loader('@qfe/font-subset-loader')\n    .options({\n      glyphs: '${content}',\n    });`;
      const outputs: string[] = [];
      outputConfig.forEach(_ => {
        let texts = '';
        [...document.querySelectorAll(`.${_.cls}`)].forEach(el => {
          texts = `${texts}${el.innerText}`;
        });
        texts = `${texts}-`
          .split('')
          .filter(char => char !== ' ')
          .join('');
        outputs.push(makeOutput([...new Set([...texts.split('')])].join(''), _.ruleName, _.fontFilename));
      });
      console.log(outputs.join('\n\n'));
    };
  }
}

export default debugHook;
